export default {"src":"/_next/static/media/gamechangers.f5d1a763.svg","height":131,"width":121};